export default __webpack_public_path__ + "static/media/logo-rpc.4cd3399f.png";